const template = document.querySelector('[data-flash-notice-template]');

function normalizeCreateOptions(options) {
  if (typeof options === 'string') {
    return { type: options };
  }

  return options || {};
}

function hideExistingNotices() {
  document
    .querySelectorAll('[data-flash-notice]:not([data-flash-notice-template])')
    .forEach((notice) => {
      notice.hidden = true;
    });
}

function setAction(notice, action) {
  if (!action) return;

  const actionElement = notice.querySelector('[data-flash-action]');
  if (!actionElement) return;

  if (action.href) {
    actionElement.setAttribute('href', action.href);
  }

  const label = actionElement.querySelector('span');
  if (label && action.text) {
    label.textContent = action.text;
  }

  const icon = actionElement.querySelector('use');
  if (icon && action.icon) {
    icon.setAttribute('href', `#${action.icon}`);
  }
}

export function init() {
  // Show flash notices
  document.querySelectorAll('[data-flash-ready]').forEach(function (el) {
    el.removeAttribute('data-flash-ready');
    el.hidden = false;

    // If it's NOT an error, auto-dismiss after 10 seconds
    if (!el.classList.contains('flash-notice--error')) {
      setTimeout(() => {
        el.hidden = true;
      }, 10000);
    }
  });

  // Dismiss flash notices
  document.querySelectorAll('[data-flash-dismiss]').forEach(function (el) {
    // Remove any existing event listeners for click before adding a new one
    el.removeEventListener('click', el._flashDismissHandler);
    el._flashDismissHandler = function () {
      const flashNotice = el.closest('[data-flash-notice]');
      if (flashNotice) flashNotice.hidden = true;
    };
    el.addEventListener('click', el._flashDismissHandler);
  });
}

export function create(text, options = {}) {
  if (!template) return null;

  const {
    action = null,
    hidePrevious = false,
    type = 'notice',
  } = normalizeCreateOptions(options);

  if (hidePrevious) {
    hideExistingNotices();
  }

  let cloned;

  if (template instanceof HTMLTemplateElement) {
    // If using a real <template> element, clone its first element child.
    cloned = template.content.firstElementChild.cloneNode(true);
  } else {
    // Otherwise clone the element itself.
    cloned = template.cloneNode(true);
  }

  // Ensure we are working with the actual notice element
  const notice =
    cloned.matches && cloned.matches('[data-flash-notice]')
      ? cloned
      : cloned.querySelector
      ? cloned.querySelector('[data-flash-notice]') || cloned
      : cloned;

  const textElement = notice.querySelector('p');
  if (textElement) {
    textElement.textContent = text;
  }

  notice.classList.remove('flash-notice--notice', 'flash-notice--error');
  notice.classList.add(`flash-notice--${type}`);
  setAction(notice, action);

  // Make sure the notice is visible immediately
  notice.setAttribute('data-flash-ready', true);
  notice.removeAttribute('data-flash-notice-template');

  // Show the notice after a short delay for animation or UX
  setTimeout(() => {
    init();
  }, 100);

  document.body.appendChild(notice);

  return notice;
}
